@if (category$ | async; as items) {
<div class="container js-special-offer">
  <label [ngClass]="activeLanguage$ | async">{{ title$ | async }}</label>

  @if (items.length > 0) {
  <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slickConfig">
    @for (data of items; track $index) {
    <div ngxSlickItem class="slide">
      <!-- ADDED div for SMARTEDIT CAROUSEL (DO NOT REMOVE)-->
      <div>
        <div class="item">
          @if ((data.title | json) !== '{}') {
          <div class="cat-name">{{ data.title }}</div>
          } @if ((data.description | json) !== '{}') {
          <div class="cat-desc">{{ data.description }}</div>
          }

          <div class="cat-bottom">
            <cx-media
              [container]="data.media"
              [class.is-missing-fish]="businessType === 'fish'"
              removeImageTitleAttr
            ></cx-media>
            <a
              tabindex="0"
              [routerLink]="getLink(data)"
              [queryParams]="getQueryParams(data?.url)"
              (click)="gtmClickPromotion(data)"
              >{{ 'productCarousel.goToPromotion' | cxTranslate }}</a
            >
          </div>
        </div>
      </div>
    </div>
    }
  </ngx-slick-carousel>
  }
</div>
}
